import { render, staticRenderFns } from "./VendorListSideMenu.vue?vue&type=template&id=337c27de"
import script from "./VendorListSideMenu.vue?vue&type=script&lang=js"
export * from "./VendorListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports